// src/styles/Layout.styles.js
import styled from 'styled-components';

export const LayoutWrapper = styled.div`
    display: flex;
    align-items: stretch; /* Ensure both columns stretch to fill height */
    min-height: 100vh; /* Full viewport height */
`;

export const ContentWrapper = styled.div`
    flex-grow: 1;
    padding: 20px; /* Adjust based on desired padding */
    overflow-y: auto;
`;
